import React, { useState } from 'react'
import { RequiredStar } from '../../atoms/RequiredStar'
import Grid from '../../atoms/Grid'
import SubmitButton from '../App/components/SubmitButton'
import { SubPageContainer } from '../App/components/SubPageContainer'
import '../../sass/career.sass'
import { getFetchUrl, getFetchParams } from '../../helpers'

// Tranlations
import t from '../../translations'

export default function Career(props) {

    const hideCareerForm = true

    const {checkServerUp, noUser, user, lang} = props

    const initialFormData = {
        companyName: '',
        companyUrl: '',
        companyJobTitle: '',
        companyJobPostUrl: '',
        companyTimezone: '',
        contactType: '',
        contactName: '',
        contactPhone: '',
        contactMessage: '',
        socialLinkedin: '',
        socialBluesky: '',
        socialEmail: '',
    }

    const [formData, setFormData] = useState(initialFormData)
    const [saveSuccess, setSaveSuccess] = useState(false)

    const updateFormData = (e, formField) => {
        setFormData((previousState) => ({
            ...previousState,
            [formField]: e.target.value,
        }))
    }

    const submitForm = async () => {

        const action = 'save'
        const sessionToken = user.sessionToken
        const userLanguage = lang

        const data = {
            formData,
            a: action,
            sessionToken,
            userLanguage,
        }
        const serverResponse = await fetch(getFetchUrl('career'), {
            ...getFetchParams(),
            body: JSON.stringify(data),
        })
            .catch(error => {
                checkServerUp(error, noUser)

                return
            })

        if (serverResponse && serverResponse.ok) {
            const result = await serverResponse.json()
            if (result.success) {
                setSaveSuccess(true)
                setFormData(initialFormData)
            } else {
                console.log(result.message)
            }
        } else {
            window.location.patName = 'maintenance'
    
            return 
        }
    }

    const isEnabledSubmit = (
        !!formData.companyJobTitle && !!formData.companyJobPostUrl && !!formData.companyTimezone &&
        !!formData.contactType && !!formData.contactName &&
        (!!formData.socialLinkedin || !!formData.socialBluesky || !!formData.socialEmail)
    )

    const companySectionRow = [<div className='formHeader first'>{t[lang]['Company']}</div>]

    const companyNameRow = [
        <div className='formField'>{t[lang]['Company name']}:</div>,
        <div className='formInput'>
            <input
                type='text'
                placeholder='Acme Americas'
                value={formData.companyName}
                onChange={(event) => updateFormData(event, 'companyName')}
            />
        </div>
    ]

    const companyWebsiteRow = [
        <div className='formField'>{t[lang]['Company website']}:</div>,
        <div className='formInput'>
            <input
                type='text'
                placeholder='acme.com'
                value={formData.companyUrl}
                onChange={(event) => updateFormData(event, 'companyUrl')}
            />
        </div>
    ]

    const companyPositionRow = [
        <div className='formField'>{t[lang]['Position title']}<RequiredStar />:</div>,
        <div className='formInput'>
            <input
                type='text'
                placeholder={t[lang]['Position placeholder']}
                value={formData.companyJobTitle}
                onChange={(event) => updateFormData(event, 'companyJobTitle')}
            />
        </div>
    ]

    const companyJobPostingRow = [
        <div className='formField'>{t[lang]['Job posting link']}<RequiredStar />:</div>,
        <div className='formInput'>
            <input
                type='text'
                placeholder='acme.com/career/jobposts/2372'
                value={formData.companyJobPostUrl}
                onChange={(event) => updateFormData(event, 'companyJobPostUrl')}
            />
        </div>
    ]

    const companyTimezoneRow = [
        <div className='formField'>{t[lang]['Timezone']}<RequiredStar />:</div>,
        <div className='formInput'>
            <select
                onChange={(event) => updateFormData(event, 'companyTimezone')}
            >
                <option value='' selected disabled>{t[lang]['Select']}</option>
                <option value='NOT REQUIRED'>{t[lang]['Not a requirement']}</option>
                <option value='-3'>UTC&#8209;3</option>
                <option value='-4'>UTC&#8209;4</option>
                <option value='-5'>UTC&#8209;5</option>
                <option value='-6'>UTC&#8209;6</option>
                <option value='-7'>UTC&#8209;7</option>
                <option value='-8'>UTC&#8209;8</option>
            </select>
        </div>
    ]

    const contactSectionRow = [
        <div className='formHeader'>{t[lang]['Contact']}</div>
    ]

    const contactTypeRow = [
        <div className='formField'>{t[lang]['Type']}<RequiredStar />:</div>,
        <div className='formInput'>
            <input
                type='radio'
                name='contactType'
                checked={formData.contactType === 'Employer'}
                onChange={(event) => {
                    if (event.target.checked) {
                        event.target.value = 'Employer'
                        updateFormData(event, 'contactType')
                    }
                }}
            /> {t[lang]['Employer']}<br />
            <input
                type='radio'
                name='contactType'
                checked={formData.contactType === 'Recruiter'}
                onChange={(event) => {
                    if (event.target.checked) {
                        event.target.value = 'Recruiter'
                        updateFormData(event, 'contactType')
                    }
                }}
            /> {t[lang]['Recruiter']}
        </div>
    ]

    const constactNameRow = [
        <div className='formField'>{t[lang]['Name']}<RequiredStar />:</div>,
        <div className='formInput'>
            <input
                type='text'
                placeholder='John Doe'
                value={formData.contactName}
                onChange={(event) => updateFormData(event, 'contactName')}
            />
        </div>
    ]

    const contactPhoneRow = [
        <div className='formField'>{t[lang]['Phone']}:</div>,
        <div className='formInput'>
            <input
                type='text'
                placeholder='+1 514 123 4567'
                value={formData.contactPhone}
                onChange={(event) => updateFormData(event, 'contactPhone')}
            />
        </div>
    ]

    const contactMessageRow = [
        <div className='formField'>{t[lang]['Message']}:</div>,
        <div className='formInput'>
            <textarea
                placeholder={t[lang]['Message placeholder']}
                value={formData.contactMessage}
                onChange={(event) => updateFormData(event, 'contactMessage')}
            />
        </div>
    ]

    const socialSectionRow = [
        <h2>{t[lang]['One of the 3 below is required.']}</h2>
    ]

    const socialLinkedinRow = [
        <div className='formField'>{t[lang]['LinkedIn']}:</div>,
        <div className='formInput'>
            <input
                type='text'
                placeholder='https://www.linkedin.com/in/john-doe'
                value={formData.socialLinkedin}
                onChange={(event) => updateFormData(event, 'socialLinkedin')}
            />
        </div>
    ]

    const socialBlueskyRow = [
        <div className='formField'>{t[lang]['BlueSky']}:</div>,
        <div className='formInput'>
            <input
                type='text'
                placeholder='https://bsky.app/profile/john-doe.bsky.social'
                value={formData.socialBluesky}
                onChange={(event) => updateFormData(event, 'socialBluesky')}
            />
        </div>
    ]

    const socialEmailRow = [
        <div className='formField'>{t[lang]['Email']}:</div>,
        <div className='formInput'>
            <input
                type='text'
                placeholder='john.doe@example.com'
                value={formData.socialEmail}
                onChange={(event) => updateFormData(event, 'socialEmail')}
            />
        </div>
    ]

    const rowsData = [
        {
            cells: companySectionRow,
            rowClasses: ['fullWidth'],
        },
        {
            cells: companyNameRow,
        },
        {
            cells: companyWebsiteRow,
        },
        {
            cells: companyPositionRow,
        },
        {
            cells: companyJobPostingRow,
        },
        {
            cells: companyTimezoneRow,
        },
        {
            cells: contactSectionRow,
            rowClasses: ['fullWidth'],
        },
        {
            cells: contactTypeRow,
        },
        {
            cells: constactNameRow,
        },
        {
            cells: contactPhoneRow,
        },
        {
            cells: contactMessageRow,
        },
        {
            cells: socialSectionRow,
            rowClasses: ['fullWidth'],
        },
        {
            cells: socialLinkedinRow,
        },
        {
            cells: socialBlueskyRow,
        },
        {
            cells: socialEmailRow,
        },
    ]

    return (
        <SubPageContainer {...props}>

            {user && user.connected ? <>
                <h1>{t[lang].specifics_career['page title']}</h1>

                <h2>{t[lang]['My profile title']}</h2>
            </> : <br />}

            <div>
                {t[lang]['My profile content']}
            </div>

            {!hideCareerForm && <>
                <hr className='halfCenteredHr dotted' />

                {t[lang]['cv']}

                <hr />

                <h2>{t[lang]['To contact me title']}</h2>
                {t[lang]['To contact me content']}

                <div className='centeredBlock'>
                    <Grid rows={rowsData} />
                </div>

                <div className='alignRight'>
                    <SubmitButton
                        text={t[lang]['Submit']}
                        onClick={submitForm}
                        disabled={!isEnabledSubmit}
                    />
                </div>

                {saveSuccess && <h2>{t[lang]['Thanks! Your message was sent.']}</h2>}
            </>}
        </SubPageContainer>
    )
}